var _rect, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDesignDrafts = function SvgDesignDrafts(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2350_17928",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 2,
    width: 98,
    height: 98
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 98,
    height: 98,
    rx: 10,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2350_17928)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 52.9999,
    r: 6,
    transform: "rotate(-180 94 52.9999)",
    fill: "#FFF1B6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 82.0001,
    r: 15,
    transform: "rotate(-180 50 82.0001)",
    fill: "#FFDECF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2350_17928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.075 78.9091C73.925 79.2208 74 79.6104 74.3 79.7662C74.45 79.9221 74.6 80 74.825 80C74.975 80 75.05 80 75.2 79.9221L80 77.039L76.1 74L74.075 78.9091Z",
    fill: "url(#paint0_linear_2350_17928)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4096 76L92.4337 63.2492C92.8274 62.7883 93.0637 62.1738 92.9849 61.4825C92.8274 60.4071 91.41 59.4086 91.41 59.4086C90.4651 58.8709 89.284 58.7173 88.1028 59.8695L77 72.7739L81.4096 76Z",
    fill: "url(#paint1_linear_2350_17928)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 79.5172V58C60.1667 58 59 61.6414 59 62.9655V82C60.3333 80.0966 64 79.5172 64 79.5172Z",
    fill: "url(#paint2_linear_2350_17928)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.318 68H90.2614L82.3068 77.52C82.1477 77.76 81.9091 77.92 81.6705 78.08L76.1023 81.28C75.2273 81.76 74.1136 81.68 73.3182 80.96C72.5227 80.24 72.2841 79.2 72.6818 78.24L75.0682 72.64C75.1477 72.48 78.8864 68 78.8864 68H65.3636V81.6H63.7727C61.2273 81.76 59.1591 83.84 59 86.48C59 90.24 61.3068 92 64.1705 92H91.2271C92.8635 92 94 90.8571 94 89.2114V69.4628C94 68 92.7953 68 92.318 68Z",
    fill: "url(#paint3_linear_2350_17928)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2350_17928",
    x: 0,
    y: 0,
    width: 106,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.368627 0 0 0 0 0.427451 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2350_17928"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2350_17928",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2350_17928",
    x1: 80,
    y1: 74,
    x2: 74,
    y2: 74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2350_17928",
    x1: 93,
    y1: 59,
    x2: 77,
    y2: 59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2350_17928",
    x1: 64,
    y1: 58,
    x2: 59,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2350_17928",
    x1: 94,
    y1: 68,
    x2: 59,
    y2: 68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2350_17928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(58 56)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDesignDrafts);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/designDrafts.40c86b9be6f9fa2b54768df6782c9e60.svg";